import { Injectable, Injector } from '@angular/core';
import { Observable, firstValueFrom, map, of, switchMap } from 'rxjs';
import { RoleEnum, UserClaims } from '../../models';
import { AuthService } from '../auth/auth.service';
import { PermissionsApiService } from '../http';
import { IS_EXTERNAL_PAGE_TOKEN } from '../../constants';

@Injectable()
export class AuthDecoratorService extends AuthService {
  private permissionsApi: PermissionsApiService;
  private readonly isExternalPage: boolean;

  constructor(injector: Injector) {
    super(injector);
    this.permissionsApi = injector.get(PermissionsApiService);
    this.isExternalPage = injector.get(IS_EXTERNAL_PAGE_TOKEN, undefined, { optional: true });
  }

  getUser(): Observable<UserClaims> {
    return super.getUser().pipe(
      switchMap((userClaims) => {
        if (!userClaims) {
          return of(null);
        }

        if (this.isExternalPage) {
          return of(userClaims);
        }

        // if it's just user in claims we set is_custom_role to true
        if (userClaims.role.split(':')[1] === RoleEnum.User) {
          userClaims.is_custom_role = true;
        }

        return this.permissionsApi.getPermissions().pipe(
          map((permissionsObject) => ({
            ...userClaims,
            role: `anecdotes:${permissionsObject.roles[0]}`,
          })),
          map((userClaims) => {
            // TODO: AN-9388
            // We need to map exisiting Manager to Collaborator
            // So the platform can treat managers as collaborators
            // until BE is fully migrated
            if (userClaims.role?.endsWith(RoleEnum.Manager)) {
              userClaims.role = userClaims.role.replace(RoleEnum.Manager, RoleEnum.Collaborator);
            }

            return userClaims;
          }),
        );
      }),
    );
  }

  getUserAsync(): Promise<UserClaims> {
    return firstValueFrom(this.getUser());
  }
}
